import $ from 'jquery';
import slick from 'slick-carousel';
import slider from 'slider';

const setHover = (ua,$tab) => {
  const hoverCls = 'is-hover';
  if (ua.isPc) {
    $tab.hover(function(){
      const $this = $(this);
      $this.addClass(hoverCls).parent().next().css({
        width : $this.width(),
        left  : $this.position().left
      });
    }, function(){
      const $this = $(this),
            $activeItem = $this.parent().find('.is-active');
      $this.removeClass(hoverCls).parent().next().css({
        width : $activeItem.width(),
        left  : $activeItem.position().left
      });
    });
  }
};

const setTabBar = ($el) => {
   $el.parent().next().css({
      width : $el.width(),
      left  : $el.position().left
    })
};

const setTabs = (ua) => {
  const $tab  = $('.tabNavigation_item');
  if ($tab.length < 1) { return; }
  if ($tab.hasClass('is-active')) {
    $tab.filter('.is-active').each(function(){
     setTabBar($(this));
    });
  }
  $tab.on('click', function(event){
    event.preventDefault();
    const $this     = $(this),
          $wrap     = $this.parents('.tabNavigationWrap'),
          $contents = $wrap.next().find('.tabContents'),
          i         = $wrap.find('li').index(this),
          activeCls = 'is-active';
    if ($contents.find('.newsSlider')) {
      const $el = $contents.eq(i).find('.newsSlider');
      slider.reloadNewsSlider($el);
    }
    $contents.removeClass(activeCls);
    $contents.eq(i).addClass(activeCls);
    $this.siblings().removeClass(activeCls);
    $this.addClass(activeCls);
    setTabBar($this);
  });
  setHover(ua,$tab);
};

module.exports = {
  setTabs : setTabs
};



// WEBPACK FOOTER //
// ./src/js/modules/tab.js